import Close from './close/default.svg';
import CloseBrandBlue from './close brand blue/default.svg';
import CloseBrandRed from './close brand red/default.svg';
import TickGreen from './tick green/default.svg';
import TickBrandBlue from './tick brand blue/default.svg';

export default {
    Close,
    CloseBrandBlue,
    CloseBrandRed,
    TickGreen,
    TickBrandBlue,
};
